import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            Hi, I'm <span className="highlight">Chris Austin</span>
          </h1>
          <h2 className="hero-subtitle">
            Senior AI Engineer
          </h2>
          <p className="hero-description">
            Senior AI Engineer with 7+ years building scalable data systems and AI solutions,
            from ML pipelines to multi-agent GenAI apps. Experienced in Python, Spark, SQL, and deploying
            across Azure, AWS, and hybrid environments.
          </p>
          <div className="hero-buttons">
            <a href="mailto:ceaustin117@gmail.com" className="btn btn-secondary">
              Get In Touch
            </a>
          </div>
        </div>
        <div className="profile-section">
          <div className="profile-image-container">
            <img 
              src="/profile-photo.jpg" 
              alt="Chris Austin - Senior AI Engineer"
              className="profile-image"
              onError={(e) => {
                // Fallback to a placeholder if image doesn't exist
                const target = e.currentTarget as HTMLImageElement;
                target.style.display = 'none';
                const placeholder = target.nextElementSibling as HTMLElement;
                if (placeholder) {
                  placeholder.style.display = 'block';
                }
              }}
            />
            <div className="profile-placeholder">
              CA
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 